import { Box, CircularProgress, Container, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Footer, Header, MixPanelTrackedLink, Textfield } from "../../components";
import { displayError } from "../../helpers";
import useForm from "../../hooks/UseForm";
import { userActions } from "../../store/actions";
import { validateForgotPassword } from "../../validations";
import useStyles from './Styles/AccountFormStyles';
import Tracking from "../../services/tracking.service";
import { PAGENAME_CONSTANTS } from "../../constants";

export function ForgotPassword() {
    const classes = useStyles();
    const errors = useSelector(state => state.validationErrors)


    const [state, setState] = useState({
        email: "",
    });
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();

    const sendResetLink = async () => {
        setLoading(true);
        await dispatch(userActions.updateLoaderState(true));
        await dispatch(userActions.forgotPassword(state.email));
        setLoading(false);
        dispatch(userActions.updateLoaderState(false));
    }

    const updateEmail = (event) => {
        setState({
            email: event.target.value
        })
    }

    const { handleChange, handleSubmit } = useForm(sendResetLink, validateForgotPassword, updateEmail, state);
    useEffect(() => {
        Tracking.trackPage({pageName: PAGENAME_CONSTANTS.FORGOT_PASSWORD})
    }, [])
    return <Box className="forgotPassword App-display-height">
        <Header />
        <Container className={`App-content ${classes.mainContainer}`}>
            <Container component="main" maxWidth="sm" className={classes.formOuter}>
                <Box className={classes.formContainer}>
                    <Box component="form" noValidate sx={{ mt: 1 }}>

                        <Typography gutterBottom align='center' component="h1" variant="h5" className={classes.formHeading}>
                            Forgot Password
                        </Typography>
                        <Textfield
                            id="email"
                            name="email"
                            label="Enter your email address"
                            onChange={handleChange}
                            error={displayError(errors?.email)}
                            helperText={errors.email}
                            type="email"
                            value={state.email}
                            sx={{
                                margin: '20px 0 20px 0'
                            }}
                            autoFocus
                            required
                            fullWidth
                        />
                        <MixPanelTrackedLink
                            type="button"
                            label="Send password reset link"
                            context="Send password reset link"
                            onClick={handleSubmit}
                            variant="contained"
                            fullWidth
                        >
                            {
                                loading ? <CircularProgress sx={{ color: 'white' }} size={25} /> : "Send password reset link"
                            }
                        </MixPanelTrackedLink>
                    </Box>
                </Box>
            </Container>
        </Container>
        <Footer />
    </Box>
}